<div [style.background-image]="'url(' + environmentSettings.splashImageUrl + ')'">
    <optsol-ngx-spinner></optsol-ngx-spinner>
    <router-outlet></router-outlet>
</div>
